import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import { ModalButtonSave, ModalButtonUpdate, } from '../../constant';
import { FormMicReturnReasons } from './FormMicReturnReasons';
import { DeleteMicReturnReasons } from './DeleteMicReturnReasons';
import { Dialog } from 'primereact/dialog';
import { Button } from 'reactstrap';


export const ModalMicReturnReasons = (props) => {

    const {
        modal, modalTitle, toggle, method, loading,
        return_reason, handleInputChange,
        validaciones, saveCreate, saveUpdate, saveDelete,
        closeDialog
    } = props;

    return (
        <Dialog
            //header={modalTitle}
            visible={modal}
            onHide={closeDialog}
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icofont icofont-trash f-24"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v38 `}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveCreate}
                        >
                            {
                                loading ? "Creando...." : "Crear"
                            }
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveUpdate}
                        >
                            {
                                loading ? "Actualizando...." : "Actualizar"
                            }
                        </Button>
                    }
                    <Button
                        size="sm"
                        color='danger'
                        type="button"
                        onClick={closeDialog}>
                        Cancelar
                    </Button>
                </>
            }

        >

            {
                method === "create"
                    ?
                    <FormMicReturnReasons
                        button={ModalButtonSave}
                        {...{ closeDialog, loading, handleInputChange, methodAction: saveCreate }}
                    />
                    :
                    (method === "update")
                        ?
                        <FormMicReturnReasons
                            button={ModalButtonUpdate}
                            {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveUpdate, return_reason, }}
                        />
                        :
                        null
            }
        </Dialog>
    )
}
